function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.6832 11.3438H2.31679C1.78054 11.3438 1.34554 10.9253 1.34554 10.4089C1.34554 9.89237 1.78028 9.47387 2.31653 9.47387H3.14394C3.58529 6.0163 6.43831 3.2692 10.0289 2.84422V0.934983C10.0289 0.418498 10.4636 0 10.9999 0C11.5363 0 11.9709 0.418498 11.9709 0.934983V2.84422C15.5615 3.2692 18.4145 6.01643 18.8558 9.47387H19.6832C20.2196 9.47387 20.6542 9.89237 20.6542 10.4089C20.6542 10.9253 20.2196 11.3438 19.6832 11.3438ZM16.8956 9.47387C16.4303 6.74447 13.9644 4.65484 11.0001 4.65484C8.03578 4.65484 5.56986 6.74447 5.10456 9.47387H16.8956Z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.1382 24.13H21.029C21.5654 24.13 22 24.5485 22 25.065C22 25.5815 21.5654 26 21.029 26H0.970988C0.434744 26 0 25.5815 0 25.065C0 24.5485 0.434744 24.13 0.970988 24.13H1.86171V19.2842H0.970988C0.434744 19.2842 0 18.8657 0 18.3492C0 17.8327 0.434744 17.4142 0.970988 17.4142H3.08243V14.4369H2.31678C1.78053 14.4369 1.34579 14.0184 1.34579 13.5019C1.34579 12.9854 1.78053 12.5669 2.31678 12.5669H19.6832C20.2196 12.5669 20.6542 12.9854 20.6542 13.5019C20.6542 14.0184 20.2196 14.4369 19.6832 14.4369H18.9176V17.4142H21.029C21.5654 17.4142 22 17.8327 22 18.3492C22 18.8657 21.5654 19.2842 21.029 19.2842H20.1382V24.13ZM16.0544 24.13H18.1962V19.2842H16.0544V24.13ZM11.971 17.4142H13.5023V14.4369H11.971V17.4142ZM8.49783 17.4142H10.0291V14.4369H8.49783V17.4142ZM10.0291 19.2842H7.88753V24.13H10.0291V19.2842ZM14.1125 19.2842H11.971V24.13H14.1125V19.2842ZM15.4444 17.4142H16.9757V14.4369H15.4444V17.4142ZM6.55572 14.437H5.02441V17.4144H6.55572V14.437ZM5.94543 19.2842H3.80368V24.13H5.94543V19.2842Z",
  fill: "#6F62FF"
});

var SvgWorldview = function SvgWorldview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWorldview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/worldview.e2d41da6.svg";
export { ForwardRef as ReactComponent };